import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Button from "@mui/material/Button";
import logo from "../assets/new icons/Comply Extractor 1.png";
import emailIcon from "../assets/new icons/Email Icon.svg";
import passwordIcon from "../assets/new icons/Password Icon.svg";
import rightArrowIcon from "../assets/new icons/extraction review/right arrow.svg";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputBase from "@mui/material/InputBase";
import { Typography, Box, Paper } from "@mui/material";
import { useSharedValue } from "../components/Constants/constants";
import { useUserSettings } from "../contexts/UserSettingsContext";
import { BASE_URL, appVersion } from "../App_Settings/app_settings";
import "./Login.css"; // Import the new CSS file

const Login = () => {
  const history = useHistory();
  const [username, setUsername] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const { isDirectNavigation, updateDirectNavigation } = useSharedValue();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const { notifications, handleNotificationList } = useSharedValue();
  const { selectedRows, handleSelectedRows } = useSharedValue();
  const [pageLoaded, setPageLoaded] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // User settings context for MFA check and admin settings
  const { loadUserSettings, shouldShowMFAGate, refreshSettings } = useUserSettings();

  document.addEventListener("contextmenu", (event) => event.preventDefault());
  // // Disable F12 key and Ctrl+Shift+I combo
  // document.addEventListener('keydown', event => {
  //   if (event.keyCode === 123 || (event.ctrlKey && event.shiftKey && event.keyCode === 73)) {
  //     event.preventDefault();
  //   }
  // });

  const onChange = (e) => {
    const { name, value } = e.target;
    if (name === "username") setUsername(value);
    if (name === "password") setPassword(value);
  };

  const handlePasswordReset = () => {
    history.push("/passwordReset");
  };

  // Set page as loaded on mount
  useEffect(() => {
    setPageLoaded(true);
  }, []);

  // SECURITY FIX: Public self-registration disabled. New users created only by admins.
  const handleRegistration = () => {
    history.push({
      pathname: "/login",
      state: { someValue: true },
    });
  };

  const doLogin = async (forceLogin = false) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/users/authenticate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Username: username,
          Password: password,
          ForceLogin: forceLogin,
        }),
      });

      const data = await response.json();

      // Handle session limit reached (409 Conflict)
      if (response.status === 409 && data.errorCode === "SESSION_LIMIT_REACHED") {
        setIsLoading(false);
        const confirmForce = window.confirm(
          `${data.message}\n\nDo you want to terminate the other session(s) and log in here?`
        );
        if (confirmForce) {
          // Retry with ForceLogin = true
          await doLogin(true);
        }
        return;
      }

      if (data.userId !== undefined) {
        const currentPath = history.location.pathname;

        // Check if MFA screen should be shown (two-step token model)
        if (data.showMFAScreen === true) {
          // MFA required — do NOT store real JWT (server didn't issue one)
          // Store only the temporary MFA token in sessionStorage
          sessionStorage.setItem("mfaToken", data.mfaToken || "");
          sessionStorage.setItem("mfaUserId", data.userId || "");
          sessionStorage.setItem("showEmail", data.showEmail ? "true" : "false");
          sessionStorage.setItem("showPhone", data.showPhone ? "true" : "false");
          sessionStorage.setItem("mobileNumber", data.mobileNumber || "");
          sessionStorage.setItem("mfaFirstName", data.firstName || "");

          setIsLoading(false);

          // Redirect to MFA verification screen
          history.push({
            pathname: "/mfa-verify",
            state: { someValue: true },
          });
        } else {
          // No MFA required — store the real JWT and session token
          localStorage.setItem("token", JSON.stringify(data));

          if (data.sessionToken) {
            localStorage.setItem("sessionToken", data.sessionToken);
          }

          updateDirectNavigation(true);
          setIsLoggedIn(true);
          localStorage.removeItem("SelectedFilesList");
          localStorage.removeItem("notifications_list");
          handleNotificationList([]);
          handleSelectedRows([]);

          if (refreshSettings) {
            console.log("Login: Triggering refreshSettings after successful login");
            refreshSettings();
          }

          setIsLoading(false);

          // Proceed to dashboard
          history.push({
            pathname: "/dashboard",
            state: { someValue: true },
          });
        }
      } else {
        // Check if account requires verification (returned as BadRequest with requiresVerification)
        if (data.requiresVerification) {
          setIsLoading(false);
          if (!data.isMobileVerified) {
            sessionStorage.setItem("pendingMobileOtp", "1");
          }
          history.push({
            pathname: "/verify-account",
            state: {
              email: data.email || username,
              firstName: "",
              isEmailVerified: data.isEmailVerified || false,
              isMobileVerified: data.isMobileVerified || false,
            },
          });
          return;
        }
        // Incorrect password or other error — display backend message directly
        setIsLoading(false);
        alert(data.message || "An error occurred. Please try again.");
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error during authentication", error);
      alert("An error occurred. Please try again.");
    }
  };

  const submitForm = async (e) => {
    // Check if username or password is empty
    if (!username || !password) {
      setIsLoading(false); // Stop loading since validation failed
      alert("Username and Password are mandatory fields. Please enter both and try again.");
      return; // Exit the function early
    }
    e.preventDefault();
    await doLogin(false);
  };

  // Handle "Enter" key press for form submission
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      submitForm(e); // Call submitForm when Enter is pressed
    }
  };

  // Only render the login form if page has been loaded (after refresh)
  if (!pageLoaded) {
    return (
      <div
        className="login-div"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          backgroundImage: "url(/background.png)",
        }}
      >
        <CircularProgress style={{ color: "#fff" }} size={40} />
      </div>
    );
  }

  return (
    <div className="login-page">
      {/* Top Navigation */}
      {/* <TopNavigation
        onPricingClick={() => {}} // Add pricing handler if needed
        onContactClick={() => {}} // Add contact handler if needed
        onSignInClick={() => {}} // Not used on login page
        onSignUpClick={handleRegistration}
        showSignIn={false} // Hide Sign In button on login page
      /> */}

      {/* Main Content Section */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #2aa7e0 0%, #1a5276 100%)",
          minHeight: "100vh",
          backgroundImage: "url(/background.png)",
          backgroundSize: "cover",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <Paper
          elevation={3}
          sx={{ p: 4, borderRadius: 4, bgcolor: "#fff", maxWidth: 420, width: "100%", mx: 2 }}
        >
          <Box sx={{ textAlign: "center", mb: 3 }}>
            <Typography variant="h4" sx={{ color: "#2aa7e0", fontWeight: 700, mb: 2 }}>
              <h1 className="text-center">
                <img className="logo" src={logo} alt="logo" />
              </h1>
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography
              variant="body2"
              sx={{
                color: "#6A6A6B",
                mb: 0.75,
                fontSize: "14.33px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
              }}
            >
              Email Address
            </Typography>
            <InputBase
              type="text"
              name="username"
              value={username}
              onChange={onChange}
              placeholder="Please enter your email"
              autoComplete="off"
              inputProps={{ autoComplete: "off" }}
              fullWidth
              startAdornment={
                <InputAdornment position="start">
                  <img
                    src={emailIcon}
                    alt="email"
                    style={{
                      width: "20px",
                      height: "20px",
                      minWidth: "20px",
                      minHeight: "20px",
                      marginRight: 8,
                    }}
                  />
                </InputAdornment>
              }
              sx={{
                bgcolor: "#ffffff",
                borderRadius: "3.56px",
                border: "0.89px solid #DDDDDD",
                px: "10.68px",
                height: "42.73px",
                fontSize: "14.33px",
                fontFamily: "Poppins, sans-serif",
                color: "#6A6A6B",
                "& .MuiInputAdornment-positionStart": { marginRight: 0 },
                "& input": { padding: 0, outline: "none" },
                "& input::placeholder": { color: "#6A6A6B" },
                "&.Mui-focused": { border: "0.89px solid #DDDDDD" },
                "& input:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 1000px #ffffff inset",
                  WebkitTextFillColor: "#6A6A6B",
                  transition: "background-color 5000s ease-in-out 0s",
                },
                "& input:-webkit-autofill:hover": {
                  WebkitBoxShadow: "0 0 0 1000px #ffffff inset",
                  WebkitTextFillColor: "#6A6A6B",
                },
                "& input:-webkit-autofill:focus": {
                  WebkitBoxShadow: "0 0 0 1000px #ffffff inset",
                  WebkitTextFillColor: "#6A6A6B",
                },
              }}
            />
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography
              variant="body2"
              sx={{
                color: "#6A6A6B",
                mb: 0.75,
                fontSize: "14.33px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
              }}
            >
              Password
            </Typography>
            <InputBase
              type={showPassword ? "text" : "password"}
              name="password"
              value={password}
              onChange={onChange}
              placeholder="Please enter your password"
              onKeyDown={handleKeyDown}
              autoComplete="new-password"
              inputProps={{ autoComplete: "new-password" }}
              fullWidth
              startAdornment={
                <InputAdornment position="start">
                  <img
                    src={passwordIcon}
                    alt="password"
                    style={{
                      width: "20px",
                      height: "20px",
                      minWidth: "20px",
                      minHeight: "20px",
                      marginRight: 8,
                    }}
                  />
                </InputAdornment>
              }
              sx={{
                bgcolor: "#ffffff",
                borderRadius: "3.56px",
                border: "0.89px solid #DDDDDD",
                px: "10.68px",
                height: "42.73px",
                fontSize: "14.33px",
                fontFamily: "Poppins, sans-serif",
                color: "#6A6A6B",
                "& .MuiInputAdornment-positionStart": { marginRight: 0 },
                "& input": { padding: 0, outline: "none" },
                "& input::placeholder": { color: "#6A6A6B" },
                "&.Mui-focused": { border: "0.89px solid #DDDDDD" },
                "& input:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 1000px #ffffff inset",
                  WebkitTextFillColor: "#6A6A6B",
                  transition: "background-color 5000s ease-in-out 0s",
                },
                "& input:-webkit-autofill:hover": {
                  WebkitBoxShadow: "0 0 0 1000px #ffffff inset",
                  WebkitTextFillColor: "#6A6A6B",
                },
                "& input:-webkit-autofill:focus": {
                  WebkitBoxShadow: "0 0 0 1000px #ffffff inset",
                  WebkitTextFillColor: "#6A6A6B",
                },
              }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                    size="small"
                  >
                    {showPassword ? (
                      <Visibility sx={{ fontSize: 20, color: "#2aa7e0" }} />
                    ) : (
                      <VisibilityOff sx={{ fontSize: 20, color: "#2aa7e0" }} />
                    )}
                  </IconButton>
                </InputAdornment>
              }
            />
          </Box>

          <Box sx={{ textAlign: "right", mb: 3 }}>
            <Typography
              variant="body2"
              onClick={handlePasswordReset}
              sx={{
                color: "#2aa7e0",
                fontSize: "13px",
                cursor: "pointer",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              Forgot Password?
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
            <Button
              onClick={submitForm}
              variant="contained"
              disabled={isLoading}
              sx={{
                bgcolor: "#2aa7e0",
                color: "#fff",
                fontWeight: 700,
                borderRadius: 2,
                fontSize: "14.33px",
                width: "200px",
                px: 3,
                py: 1,
                textTransform: "none",
                "&:hover": { bgcolor: "#2aa7e0" },
              }}
            >
              {isLoading ? (
                <CircularProgress size={20} sx={{ color: "#fff" }} />
              ) : (
                <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                  <Box sx={{ flex: 1 }} />
                  <span>Sign in</span>
                  <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
                    <img
                      src={rightArrowIcon}
                      alt=""
                      style={{ width: 12, height: 12, filter: "brightness(0) invert(1)" }}
                    />
                  </Box>
                </Box>
              )}
            </Button>
            {/* <Button
                    onClick={handleRegistration}
                    variant="contained"
                    className="free-trial-btn"
                    sx={{
                      bgcolor: "#F2AE33",
                      color: "#fff",
                      fontWeight: 600,
                      borderRadius: 2,
                      px: 3,
                      py: 1,
                      textTransform: "none",
                      "&:hover": { bgcolor: "#e6a200" },
                    }}
                  >
                    Sign up
                  </Button> */}
          </Box>
        </Paper>
      </Box>
      {/* Version label bottom-right */}
      <Box
        sx={{
          position: "fixed",
          bottom: 10,
          right: 14,
          color: "#ffffff",
          fontSize: "12px",

          pointerEvents: "none",
        }}
      >
        VERSION: {appVersion}
      </Box>
    </div>
  );
};

export default Login;
